import { NONE_VALUE } from '../constants';

export const createPageLevel = (level: string | number | undefined) => {
  if (typeof level === 'number') {
    return level;
  }

  if (typeof level === 'string') {
    return Number(level);
  }

  return NONE_VALUE;
};
